import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { BaseAPIService } from './api.base.service';

@Injectable()
export class FiledownloadService {

  public init = false;
  constructor(private readonly baseApiService: BaseAPIService) { }

  public Download(URL: string, body: any, fileName: string) {
    return this.baseApiService.DOWNLOAD(URL, body).subscribe(result => {
      this.blobldownload(result, fileName);
    });
  }

  public DownloadGet(URL: string, fileName: string) {
    return this.baseApiService.DOWNLOADGet(URL).subscribe(result => {
      this.blobldownload(result, fileName);
    });
  }

  blobldownload(result: any, fileName: string) {
    const blob = new Blob([result], { type: "application/octet-stream" });
    saveAs(blob, fileName);
    this.init = true;
  }
}
